@if (!isNoAudienceParticipationActive) {
  <div
    speakingParticipantsHeight
    [bubbleSizePx]="125"
    [isMobile]="isMobile()"
    (newArraySize)="organizeParticipants($event)"
    class="speakers-container"
  >
    <app-emote-stream></app-emote-stream>
    @for (speaker of toShowSpeakingParticipants(); track speaker.userId) {
      <div
        class="speaker-wrapper"
        [ngClass]="{ hidden: $index + 1 > toApplySize() }"
        [attr.aria-label]="'Speaker ' + speaker.name"
      >
        <app-video-bubble
          [ringColor]="getParticipantRingColor(speaker.userId)"
          [visualIndicators]="newVisualIndicators()"
          [showAnimation]="true"
          [user]="speaker"
          [size]="80"
          [isSpeaking]="true"
        ></app-video-bubble>
      </div>
    }
  </div>
}
